module.exports = __webpack_public_path__ + "static/media/hdi-vial.597e7c43.svg";